import { TEST_STRIPE_PUBLIC_KEY, PROD_STRIPE_PUBLIC_KEY } from "./secrets";

const client_hostname = window && window.location && window.location.hostname;
// These should not be edited for testing; use the test_* constants below instead.
// NOTE: Must match api_host and client_host in reg_new_conf.ini
// The server-side (PHP) WisCon Reg API endpoint:
const prod_api_prefix = 'https://api.wiscon.net/';
// The server-side Zambia API endpoint:
const prod_zambia_prefix = 'https://program.wiscon.net/';
// The hostname of the client (react) app:
const prod_client_hostname = 'reg.wiscon.net';

// While one could simply edit the above for testing, keeping these separate
// NOTE: Must match api_host and client_host in reg_new_conf.ini
// helps ensure that testing doesn't accidentally write to prod :)
const test_api_prefix = 'http://api-local.test:9080/';
const test_zambia_prefix = 'http://program-local.test:9000/';
const test_client_hostname = '127.0.0.1:3000';

class SdlcUtil {

    apiHostPrefix() {
        if (isTestEnvironment()) {
            return test_api_prefix;
        } else {
            return prod_api_prefix;
        }
    }

    clientPrefix() {
        if (isTestEnvironment()) {
            return `http://${test_client_hostname}/`;
        } else {
            return `https://${prod_client_hostname}/`;
        }
    }

    apiPath(path) {
        let apiPath = path;
        if (path.indexOf('/') === 0) {
            apiPath = path.substring(1);
        }
        return apiPath;
    }
    
    serverUrl(path) {
        return `${this.apiHostPrefix()}${this.apiPath(path)}`;
    }

    clientUrl(path) {
        return `${this.clientPrefix()}${this.apiPath(path)}`;
    }

    zambiaHostPrefix() {
        if (isTestEnvironment()) {
            return test_zambia_prefix;
        } else {
            return prod_zambia_prefix;
        }
    }
    
    passwordResetUrl() {
        return this.zambiaHostPrefix() + 'ForgotPassword.php';
    }
}


function isTestEnvironment() {
    if (client_hostname === prod_client_hostname) {
        return false;
    } else {
        return true;
    }
}

export function stripePublicKey() {
    if (isTestEnvironment()) {
        return TEST_STRIPE_PUBLIC_KEY;
    } else {
        return PROD_STRIPE_PUBLIC_KEY;
    }
}

export const sdlc = new SdlcUtil();
